export type QuickPreset = {
  id: string;
  label: string;
  description?: string;
  duration: number; // seconds
  background: string;
  audio: 'on' | 'off';
  introVoice?: boolean;
  ratio: {
    inhale: number;
    hold_full: number;
    exhale: number;
    hold_empty: number;
  };
  breathingStyle?: string;
  overrides?: {
    affirmations?: boolean;
    affirmationType?: string;
    affirmationMode?: 'regular' | 'subliminal';
    backgroundSound?: 'on' | 'off';
    phaseChime?: boolean;
    voiceGuidance?: boolean;
  };
};

export const QUICK_PRESETS: QuickPreset[] = [
  {
    id: 'panicAttackRelief',
    label: 'Panic Attack Relief Breathing',
    description:
      'Quickly regulates breathing during panic with a calming rhythm.',
    duration: 300,
    background: 'sunset_field',
    audio: 'on',
    introVoice: false,
    ratio: { inhale: 4, hold_full: 2, exhale: 6, hold_empty: 2 },
    breathingStyle: 'circle',
  },
  {
    id: 'panicAttackAffirmations',
    label: 'Panic Attack Relief Breathing + Affirmations',
    description:
      'The Panic Attack Relief rhythm with grounding affirmations to reinforce calm.',
    duration: 300,
    background: 'sunset_field',
    audio: 'on',
    introVoice: false,
    ratio: { inhale: 4, hold_full: 2, exhale: 6, hold_empty: 2 },
    breathingStyle: 'circle',
    overrides: {
      affirmations: true,
      affirmationType: 'panic_attack_relief',
      backgroundSound: 'on',
      phaseChime: true,
      voiceGuidance: false,
    },
  },
  {
    id: 'reduceStress',
    label: 'Reduce Stress Breathing',
    description: 'Balanced inhales and holds to calm the nervous system.',
    duration: 300,
    background: 'sunset_field',
    audio: 'on',
    ratio: { inhale: 4, hold_full: 4, exhale: 6, hold_empty: 0 },
    breathingStyle: 'circle',
  },
  {
    id: 'relaxBody',
    label: 'Relax the Body Breathing',
    description: 'Longer holds to encourage muscle relaxation.',
    duration: 300,
    background: 'sunset_field',
    audio: 'on',
    ratio: { inhale: 4, hold_full: 7, exhale: 8, hold_empty: 0 },
    breathingStyle: 'circle',
  },
  {
    id: 'emotionalBalance',
    label: 'Emotional Balance Breathing',
    description: 'Even rhythm for steady, calm breathing.',
    duration: 300,
    background: 'sunset_field',
    audio: 'on',
    ratio: { inhale: 5, hold_full: 0, exhale: 5, hold_empty: 0 },
    breathingStyle: 'circle',
  },
  {
    id: 'boostFocus',
    label: 'Boost Focus Breathing',
    description: 'Short, consistent cycles for alertness and focus.',
    duration: 300,
    background: 'sunset_field',
    audio: 'on',
    ratio: { inhale: 4, hold_full: 4, exhale: 4, hold_empty: 4 },
    breathingStyle: 'circle',
  },
  {
    id: 'calmAnxiety',
    label: 'Calm Anxiety Breathing',
    description: 'Gentle rhythm to stabilize rapid breath patterns.',
    duration: 300,
    background: 'sunset_field',
    audio: 'on',
    ratio: { inhale: 4, hold_full: 2, exhale: 6, hold_empty: 2 },
    breathingStyle: 'circle',
  },
  {
    id: 'eveningRelaxation',
    label: 'Evening Relaxation Breathing',
    description: 'Slow and long exhale for bedtime relaxation.',
    duration: 300,
    background: 'sunset_field',
    audio: 'on',
    ratio: { inhale: 4, hold_full: 7, exhale: 8, hold_empty: 0 },
    breathingStyle: 'circle',
  },
];

export default QUICK_PRESETS;
